import React from "react";
import "./testimonials.css";
import Image1 from "../../assets/avatar-4.svg";
import Image2 from "../../assets/avatar-3.svg";
import { Pagination } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

//Import Swiper Styles
import "swiper/css";
import "swiper/css/pagination";

const data = [
  {
    id: 1,
    image: Image2,
    title: "Nik Rathore",
    subtitle: "React Developer",
    comment:
      "She took our jumbled ideas and turned them into a stunning, user-friendly website. Highly recommended! 👍",
  },
  {
    id: 2,
    image: Image1,
    title: "Akshay Giri",
    subtitle: "Frontend Developer",
    comment:
      "Working with Saloni was a breeze. She turned our ideas into a fully functional website application that exceeded our expectations. ✨",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials container section">
      <h2 className="section__title">Clients & Reviews</h2>

      <Swiper
        className="testimonials__container grid"
        // install Swiper modules
        modules={[Pagination]}
        spaceBetween={30}
        loop={true}
        grabCursor={true}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {data.map(({ id, image, title, subtitle, comment }) => {
          return (
            <SwiperSlide className="testimonial__item" key={id}>
              <div className="thumb">
                <img src={image} alt="" />
              </div>
              <h3 className="testimonials__title">{title}</h3>
              <span className="subtitle">{subtitle}</span>
              <div className="comment">{comment}</div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
